import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const PrivacyPolicy = () => {
  return (
    <Container maxWidth="md" sx={{ marginTop: 4, marginBottom: 4 }}>
      <Typography variant="h4" gutterBottom>
        Politique de Confidentialité
      </Typography>

      <Typography variant="body1" gutterBottom>
        Dernière mise à jour : 27 Août 2024
      </Typography>

      <Typography variant="body1" paragraph>
        Merci d'utiliser GestionCantine ("nous", "notre" ou "nos"). Nous nous engageons à protéger et à respecter votre vie privée. Cette politique de confidentialité explique comment nous collectons, utilisons, stockons et partageons vos informations lorsque vous utilisez notre application.
      </Typography>

      <Typography variant="h6" gutterBottom>
        1. Informations que nous collectons
      </Typography>
      
      <Typography variant="body1" paragraph>
        Nous collectons différents types d'informations pour vous fournir et améliorer notre service.
      </Typography>
      
      <Typography variant="subtitle1" gutterBottom>
        a. Informations que vous nous fournissez :
      </Typography>

      <Typography variant="body1" paragraph>
        Informations d'identification : Lorsque vous créez un compte ou utilisez notre application, nous pouvons vous demander de fournir des informations personnelles telles que votre nom, adresse e-mail, numéro de téléphone, etc.
      </Typography>

      <Typography variant="body1" paragraph>
        Contenu généré par l'utilisateur : Toutes les informations ou contenus que vous partagez ou téléchargez via notre application, tels que les commentaires, les photos, ou d'autres types de contenu.
      </Typography>

      <Typography variant="subtitle1" gutterBottom>
        b. Informations collectées automatiquement :
      </Typography>

      <Typography variant="body1" paragraph>
        Données d'utilisation : Nous recueillons des informations sur votre utilisation de l'application, y compris les pages que vous visitez, le temps passé sur ces pages, les actions effectuées et d'autres données de diagnostic.
      </Typography>

      <Typography variant="body1" paragraph>
        Données techniques : Nous pouvons collecter des informations sur votre appareil, telles que l'adresse IP, le type de navigateur, la version du système d'exploitation, et d'autres données techniques.
      </Typography>

      <Typography variant="h6" gutterBottom>
        2. Utilisation de vos informations
      </Typography>

      <Typography variant="body1" paragraph>
        Nous utilisons vos informations pour :
      </Typography>

      <Typography variant="body1" paragraph>
        - Fournir et améliorer notre service : Pour gérer, maintenir et améliorer notre application.
      </Typography>

      <Typography variant="body1" paragraph>
        - Communiquer avec vous : Pour vous envoyer des mises à jour, des notifications, des informations marketing (si vous y avez consenti) ou pour répondre à vos questions.
      </Typography>

      <Typography variant="body1" paragraph>
        - Personnaliser votre expérience : Pour adapter le contenu et les publicités en fonction de vos préférences.
      </Typography>

      <Typography variant="body1" paragraph>
        - Assurer la sécurité : Pour protéger nos utilisateurs, prévenir la fraude, et appliquer nos conditions d'utilisation.
      </Typography>

      <Typography variant="h6" gutterBottom>
        3. Partage de vos informations
      </Typography>

      <Typography variant="body1" paragraph>
        Nous ne vendons pas vos informations personnelles à des tiers. Nous pouvons partager vos informations avec des tiers dans les situations suivantes :
      </Typography>

      <Typography variant="body1" paragraph>
        - Fournisseurs de services : Nous pouvons partager vos informations avec des fournisseurs de services tiers qui nous aident à fournir notre service (hébergement, analyses, publicité, etc.).
      </Typography>

      <Typography variant="body1" paragraph>
        - Obligations légales : Nous pouvons divulguer vos informations si la loi l'exige ou si nous croyons en toute bonne foi que cela est nécessaire pour se conformer à une obligation légale.
      </Typography>

      <Typography variant="body1" paragraph>
        - Transferts d'entreprise : En cas de fusion, acquisition, ou vente d'actifs, vos informations peuvent être transférées à la société acquéreuse.
      </Typography>

      <Typography variant="h6" gutterBottom>
        4. Sécurité de vos informations
      </Typography>

      <Typography variant="body1" paragraph>
        Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos informations contre l'accès non autorisé, la modification, la divulgation ou la destruction. Cependant, aucun système de transmission ou de stockage des données n'est totalement sécurisé, et nous ne pouvons garantir la sécurité absolue de vos informations.
      </Typography>

      <Typography variant="h6" gutterBottom>
        5. Vos droits
      </Typography>

      <Typography variant="body1" paragraph>
        Selon votre juridiction, vous pouvez avoir certains droits concernant vos informations personnelles, notamment :
      </Typography>

      <Typography variant="body1" paragraph>
        - Accès et rectification : Vous avez le droit d'accéder à vos informations personnelles que nous détenons et de demander leur rectification si elles sont inexactes.
      </Typography>

      <Typography variant="body1" paragraph>
        - Suppression : Vous pouvez demander la suppression de vos informations personnelles, sous réserve de certaines exceptions légales.
      </Typography>

      <Typography variant="body1" paragraph>
        - Retrait du consentement : Si vous avez consenti à la collecte, à l'utilisation ou à la divulgation de vos informations personnelles, vous pouvez retirer votre consentement à tout moment.
      </Typography>

      <Typography variant="body1" paragraph>
        Pour exercer ces droits, veuillez nous contacter à [Adresse e-mail de contact].
      </Typography>

      <Typography variant="h6" gutterBottom>
        6. Modifications de cette politique de confidentialité
      </Typography>

      <Typography variant="body1" paragraph>
        Nous pouvons mettre à jour notre politique de confidentialité de temps à autre. Nous vous informerons de toute modification en publiant la nouvelle politique de confidentialité sur cette page. Vous êtes encouragé à consulter cette politique périodiquement pour prendre connaissance de toute modification.
      </Typography>

      <Typography variant="h6" gutterBottom>
        7. Contactez-nous
      </Typography>

      <Typography variant="body1" paragraph>
        Si vous avez des questions concernant cette politique de confidentialité, veuillez nous contacter à :
      </Typography>

      <Typography variant="body1" paragraph>
        ADICOTECH
        <br />
        23 bis rue Egdar Quinet, La Courneuve 93120. France
        <br />
        adico.fidele@gmail.com
      </Typography>
    </Container>
  );
};

export default PrivacyPolicy;
